/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dev_Item_Disable_BatchingInputs */

const en_dev_item_disable_batching = /** @type {(inputs: Dev_Item_Disable_BatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disable tRPC Batching`)
};

const ar_dev_item_disable_batching = /** @type {(inputs: Dev_Item_Disable_BatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعطيل تجميع tRPC`)
};

const bn_dev_item_disable_batching = /** @type {(inputs: Dev_Item_Disable_BatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tRPC ব্যাচিং বন্ধ করুন`)
};

const de_dev_item_disable_batching = /** @type {(inputs: Dev_Item_Disable_BatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tRPC-Batching deaktivieren`)
};

const es_dev_item_disable_batching = /** @type {(inputs: Dev_Item_Disable_BatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deshabilitar el procesamiento por lotes de tRPC`)
};

const fr_dev_item_disable_batching = /** @type {(inputs: Dev_Item_Disable_BatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désactiver le traitement par lots tRPC`)
};

const pt_dev_item_disable_batching = /** @type {(inputs: Dev_Item_Disable_BatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desativar lote tRPC`)
};

const zh_dev_item_disable_batching = /** @type {(inputs: Dev_Item_Disable_BatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`禁用 tRPC 批处理`)
};

const tr_dev_item_disable_batching = /** @type {(inputs: Dev_Item_Disable_BatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tRPC Toplu İşlemini Devre Dışı Bırak`)
};

const ru_dev_item_disable_batching = /** @type {(inputs: Dev_Item_Disable_BatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отключить пакетную обработку tRPC`)
};

const pl_dev_item_disable_batching = /** @type {(inputs: Dev_Item_Disable_BatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyłącz grupowanie tRPC`)
};

/**
* | output |
* | --- |
* | "Disable tRPC Batching" |
*
* @param {Dev_Item_Disable_BatchingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const dev_item_disable_batching = /** @type {((inputs?: Dev_Item_Disable_BatchingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dev_Item_Disable_BatchingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_dev_item_disable_batching(inputs)
	if (locale === "bn") return bn_dev_item_disable_batching(inputs)
	if (locale === "de") return de_dev_item_disable_batching(inputs)
	if (locale === "es") return es_dev_item_disable_batching(inputs)
	if (locale === "fr") return fr_dev_item_disable_batching(inputs)
	if (locale === "pt") return pt_dev_item_disable_batching(inputs)
	if (locale === "zh") return zh_dev_item_disable_batching(inputs)
	if (locale === "tr") return tr_dev_item_disable_batching(inputs)
	if (locale === "ru") return ru_dev_item_disable_batching(inputs)
	if (locale === "pl") return pl_dev_item_disable_batching(inputs)
	return en_dev_item_disable_batching(inputs)
});